<!--
  stepper-nav.component.html
  --------------------------
  Horizontal step navigation bar — rendered below the header on all
  assessment flow pages.

  Step states:
    active  → bright white text, full opacity (current page)
    complete→ slightly dimmed, still clickable (already done)
    locked  → dim/muted, cursor not-allowed (not yet accessible)
-->
<nav class="stepper-nav" role="navigation" aria-label="Assessment steps">
  <div class="stepper-nav__inner">

    <ng-container *ngFor="let step of steps(); let last = last">

      <!-- Step tab -->
      <button
        class="stepper-nav__step"
        [class.stepper-nav__step--active]="getStepState(step.key) === 'active'"
        [class.stepper-nav__step--complete]="getStepState(step.key) === 'complete'"
        [class.stepper-nav__step--locked]="getStepState(step.key) === 'locked'"
        [attr.aria-current]="getStepState(step.key) === 'active' ? 'step' : null"
        [disabled]="getStepState(step.key) === 'locked'"
        (click)="navigateTo(step.key)"
      >
        {{ step.label }}
      </button>

      <!-- Separator arrow (not after last step) -->
      <span class="stepper-nav__sep" aria-hidden="true" *ngIf="!last">&gt;</span>

    </ng-container>

  </div>
</nav>
